import React from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import TabbedNav from 'app/PelatihanMandiriPage/components/TabbedNav'

import type { TabbedNavItem } from 'types/microlearning'

interface TopicHeaderProps {
  title: string
  shouldShowTab: boolean
  shouldShowInfo?: boolean
}

const TopicHeader = ({
  title,
  shouldShowTab,
  shouldShowInfo = true,
}: TopicHeaderProps) => {
  const { pathname, query } = useRouter()
  const baseUrl =
    process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || 'pelatihan-mandiri'

  const baseHref = `/${baseUrl}/topik/${query?.topik}`

  const navItems: TabbedNavItem[] = [
    {
      name: 'pelatihan',
      label: 'Pelatihan',
      href: baseHref,
    },
    {
      name: 'referensi',
      label: 'Pengayaan',
      href: `${baseHref}/referensi`,
    },
    ,
  ]

  let activeMenu = 'pelatihan'
  if (/referensi/.test(pathname)) activeMenu = 'referensi'

  const flagShowTab = shouldShowTab

  return (
    <>
      {shouldShowInfo && (
        <Text
          className={clsx(
            'px-4 pb-3 bg-white',
            !flagShowTab && 'shadow-header'
          )}
          variant="heading-lg"
        >
          {title}
        </Text>
      )}
      {flagShowTab && (
        <TabbedNav
          activeMenu={activeMenu}
          navItems={navItems}
          absolutePosition
          className="relative pt-3"
        />
      )}
    </>
  )
}

export default TopicHeader
